export const roleHomePath = (role) => ({
  platform_admin: "/platform",
  qa: "/qa",
  tenant_admin: "/admin",
  branch_admin: "/admin",
  admin: "/admin",
  reception: "/reception",
  mechanic: "/mechanic",
  tester: "/tester",
  shopkeeper: "/shopkeeper",
})[role] || `/${role}`;

export const adminRoles = ["admin", "tenant_admin", "branch_admin"];
